import { combineReducers } from 'redux'
import newsReducer from './Reducers/News'
import portalsReducer from './Reducers/Portals'
import shareReducer from './Reducers/Share'
import myTopicsReducer from './Reducers/MyTopics'

const rootReducer = combineReducers({
  news: newsReducer,
  portals: portalsReducer,
  share: shareReducer,
  myTopics: myTopicsReducer,
})

export default rootReducer
